import { Box, styled } from "@mui/material";
// @ts-ignore dependency exists, just don't know why its not accept
import type {
  UseTreeViewExpansionPublicAPI,
  // @ts-ignore dependency exists, just don't know why its not accept
} from "@mui/x-tree-view/internals/plugins/useTreeViewExpansion/useTreeViewExpansion.types";
// @ts-ignore dependency exists, just don't know why its not accept
import type { UseTreeItemIconContainerSlotProps } from "@mui/x-tree-view/useTreeItem/useTreeItem.types";
import type { UseTreeItemStatus } from "@mui/x-tree-view-pro";
import { TreeItemIcon, TreeItemIconContainer } from "@mui/x-tree-view-pro";
import React, { MouseEventHandler, useCallback } from "react";

interface TreeItemExpandIconProps {
  iconContainerProps: UseTreeItemIconContainerSlotProps;
  itemId: string;
  status: UseTreeItemStatus;
  onItemExpandToggle: UseTreeViewExpansionPublicAPI["setItemExpansion"];
}

export const TreeItemExpandIcon = ({
  iconContainerProps,
  itemId,
  status,
  onItemExpandToggle,
}: TreeItemExpandIconProps) => {
  const handleClick = useCallback<MouseEventHandler<HTMLDivElement>>(
    (e) => {
      onItemExpandToggle({ event: e, itemId: itemId, shouldBeExpanded: !status.expanded });
    },
    [onItemExpandToggle, itemId, status.expanded]
  );
  return (
    <ExpandIconContainer {...iconContainerProps} onClick={handleClick}>
      <TreeItemIcon status={status} />
    </ExpandIconContainer>
  );
};

const ExpandIconContainer = styled(TreeItemIconContainer)(({ theme }) => ({
  justifyContent: "flex-start",
  width: "auto",
  display: "flex",
  alignItems: "center",
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  transform: `translate(${theme.spacing(-1)}, 0px)`,
  marginRight: theme.spacing(-2),
  alignSelf: "stretch",
}));
export const ExpandIconSpacer = styled(Box)(() => ({
  width: "18px",
}));
